import React from 'react';
import { func } from 'prop-types';
import { ListItem, ListItemText, Box } from '@mui/material';
import { SimpleText } from '../../util/IntlMessages';

const ShowMore = ({ onLoadMore }) => (
  // eslint-disable-next-line
  <Box
    className="show-more"
    onClick={onLoadMore}
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      p: 0,
      // bootstrap's .text-primary compiled against the app seam ($primary:
      // $app-primary = #025c91), which primary.main matches exactly.
      color: 'primary.main',
    }}
  >
    <ListItem button>
      <ListItemText primary={<SimpleText id="messages.showMore" />} />
    </ListItem>
  </Box>
);

ShowMore.propTypes = {
  onLoadMore: func,
};

export default ShowMore;
